import React, { Component } from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import "./style.scss";
import Question from "../../containers/question/";
import PrintTemplate from "react-print";
import {
  dataToJS,
  isLoaded,
  pathToJS,
  firebaseConnect
} from "react-redux-firebase";
import BlankPage from "../blank/";
import DrawerToggle from "../../containers/drawer-toggle/";
import PrintStudentLog from "../../containers/print-student-log/";
class PrintStudentLogPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: null
    };
  }

  componentWillMount() {
    this.props.firebase.set(
      `/responses/groups/${this.props.match.params.groupId}/logs/${this.props.match.params.logId}/students/${this.props.auth.uid}/set`,
      true
    );
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
  }

  componentWillUnmount() {}

  componentWillReceiveProps(props) {
    this.setState({ responses: this.props.responses });
  }

  render() {
    if (
      isLoaded(this.props.log) &&
      isLoaded(this.props.group) &&
      isLoaded(this.props.responses)
    ) {
      return (
        <div className="flex-container">

          <div className="content log">
            <div className="page">
              <div className="max-width">
                <PrintStudentLog
                  log={this.props.log}
                  student={Object.keys(this.props.group.students)
                    .map((key, id) => ({
                      ...this.props.group.students[key],
                      _key: key
                    }))
                    .find(s => s.uid == this.props.match.params.studentId)}
                  responses={this.props.responses}
                />

              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return <BlankPage />;
    }
  }
}

export default withRouter(
  connect(({ firebase }, { match, auth }) => {
    if (auth)
      return {
        group: dataToJS(firebase, `groups/${match.params.groupId}`),
        responses: dataToJS(
          firebase,
          `/responses/groups/${match.params.groupId}/logs/${match.params.logId}/students/${match.params.studentId}`
        ),
        log: dataToJS(firebase, `/logs/${match.params.logId}`)
      };
    return null;
  })(
    firebaseConnect(({ match, auth }) => {
      console.log(
        `/responses/groups/${match.params.groupId}/logs/${match.params.logId}/students/${match.params.studentId}`
      );
      return auth
        ? [
            "/logs",
            "/groups",
            `/responses/groups/${match.params.groupId}/logs/${match.params.logId}/students/${match.params.studentId}`
          ]
        : [];
    })(PrintStudentLogPage)
  )
);



// WEBPACK FOOTER //
// ./src/routes/print-student-log/index.js